import React, { useCallback, useEffect, useState } from "react";
import { DispatchTransactionEvent } from "../events/events";
import {
  ROLE_MARKET_CONTROLLER,
  NAME_MARKET_CONTROLLER, NAME_TRADER, ROLE_TRADER, ROLE_FIRMMANAGER, NAME_FIRMMANAGER, 
  // NAME_FIRMVIEWER, ROLE_FIRMVIEWER
  ROLE_DATAFEED_SERVER, NAME_DATAFEED_SERVER, NAME_TRANSACTION_SERVER, ROLE_PUBLIC,
  ROLE_TRANSACTION_SERVER, NAME_PUBLIC, ShowError, DROPDOWN_LIST_NONE,
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, EVENT_TYPE_CHANGE_USER_STATUS, JSON_KEY_PASSWORD, 
  JSON_KEY_ROLE, JSON_KEY_FIRM, JSON_KEY_USER, JSON_KEY_SUBMITTER, JSON_KEY_STATUS,  
  ConvertToRoleId, ITEM_STATUS, ITEM_CREATE,ITEM_MODIFY, StatusSimpleOptions,
  PUBLIC_DATA_ROLE_ID, JSON_KEY_DESCRIPTION, SUSPENDED,
  NO,
  JSON_KEY_WITHDRAW_ALL_ORDERS,
  ConvertStatusFromNameToId,
  SUSPEND,
  ConvertStatus,
  STATUS_ACTIVE,
  ITEM_CANCEL_ALL_ORDERS,
  ConfirmConfirmCancelAndSubmit,
  JSON_KEY_COORDINATOR,
  ROLE_SUPER_CONTROLLER,
  NAME_SUPER_CONTROLLER,
  NAME_MARKET_CONTROLLER_VIEWER,
  ROLE_MARKET_CONTROLLER_VIEWER,
  ROLE_ADMINISTRATION_CONTROLLER,
  NAME_ADMINISTRATION_CONTROLLER,
  YES,
  NAME_YES,
  JSON_KEY_TR_DELETE_REDUNDANT_ORDERS,
  NAME_SUPER_CONTROLLER_PERFORMANCE,
  NAME_MARKET_CONTROLLER_VIEWER_PERFORMANCE,
  NAME_MARKET_CONTROLLER_PERFORMANCE,
  ROLE_MARKET_CONTROLLER_PERFORMANCE,
  ROLE_MARKET_CONTROLLER_VIEWER_PERFORMANCE,
  ROLE_SUPER_CONTROLLER_PERFORMANCE,
  BIT_MASK_HOLDINGS_REQUEST,
  BIT_MASK_ORDER_REQUEST,
  SwitchField,
  BIT_MASK_TRADE_REQUEST,
  JSON_KEY_PERMISSION,
  JSON_KEY_CHECKPOINTER,
  ITEM_CHANGE_COORDINATOR,
  ROLE_ALL_IN_ONE_SERVER,
  NAME_ALL_IN_ONE_SERVER,
  JSON_KEY_BACKUP,
  ITEM_CHANGE_BACKUP,
  EVENT_TYPE_CHANGE_COORDINATOR,
  EVENT_TYPE_CHANGE_BACKUP,
  EVENT_TYPE_USER_PASSWORD,
  EVENT_TYPE_USER_CANCEL_ALL_ORDERS,
  ITEM_FORCE_LOGOFF,
  BIT_MASK_ORDER_PAIR,
  ROLE_MARKET_MAKER,
  NAME_MARKET_MAKER,
  ROLE_TRADING_OPERATOR,
  NAME_TRADING_OPERATOR,
  JSON_KEY_LISTENING_PORT,
  JSON_KEY_PROMETHEUS_PORT,
  ROLE_FIRMVIEWER,
  NAME_FIRMVIEWER,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTSUserId } from "../../redux/globalsSlice";
import { MSGTYPE_USER_MODIFY, MSGTYPE_USER_CHANGE_STATUS, MSGTYPE_USER_CREATE, MSGTYPE_USER_PASSWORD, MSGTYPE_USER_CANCEL_ALL_ORDERS, MSG_TYPE_CHANGE_COORDINATOR, MSG_TYPE_CHANGE_BACKUP, MSG_TYPE_USER_FORCE_LOGOFF } from "../../common/msg_types";
import { RenderDropdown, InputMediumField } from "../../common/utilies";
import { yesNoOptions } from "../../common/convert_functions";

// Constants
const ITEM_PASSWORD = "password";
const DEFAULT_PASSWORD = "password";

// const CHECKPOINTER_ALLOWED_ROLES = Object.freeze([
//    ROLE_DATAFEED_SERVER,
//    ROLE_TRANSACTION_SERVER,
//    ROLE_ALL_IN_ONE_SERVER,
// ]);

const roleOptions = [
   { id: ROLE_MARKET_CONTROLLER, name: NAME_MARKET_CONTROLLER },
   { id: ROLE_MARKET_CONTROLLER_VIEWER, name: NAME_MARKET_CONTROLLER_VIEWER },
   { id: ROLE_ADMINISTRATION_CONTROLLER, name: NAME_ADMINISTRATION_CONTROLLER },
   { id: ROLE_SUPER_CONTROLLER, name: NAME_SUPER_CONTROLLER },
   { id: ROLE_TRADING_OPERATOR, name: NAME_TRADING_OPERATOR },
   { id: ROLE_MARKET_CONTROLLER_PERFORMANCE, name: NAME_MARKET_CONTROLLER_PERFORMANCE },
   { id: ROLE_MARKET_CONTROLLER_VIEWER_PERFORMANCE, name: NAME_MARKET_CONTROLLER_VIEWER_PERFORMANCE },
   { id: ROLE_SUPER_CONTROLLER_PERFORMANCE, name: NAME_SUPER_CONTROLLER_PERFORMANCE },
   { id: ROLE_TRADER, name: NAME_TRADER },
   { id: ROLE_FIRMMANAGER, name: NAME_FIRMMANAGER },
   { id: ROLE_FIRMVIEWER, name: NAME_FIRMVIEWER },
   { id: ROLE_PUBLIC, name: NAME_PUBLIC },
   { id: ROLE_MARKET_MAKER, name: NAME_MARKET_MAKER },
   { id: ROLE_DATAFEED_SERVER, name: NAME_DATAFEED_SERVER },
   { id: ROLE_TRANSACTION_SERVER, name: NAME_TRANSACTION_SERVER },
   { id: ROLE_ALL_IN_ONE_SERVER, name: NAME_ALL_IN_ONE_SERVER },
];

const UsersAdminForm = ({ rowData, onClose, userOptions, firmOptions, engineUsersOptions }) => {
   const userId = useSelector(selectTSUserId);
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);
   const [cancelAllOrders, setCancelAllOrders] = useState(NO);
   const [coordinator, setCoordinator] = useState(rowData?.coord === NAME_YES ? YES : NO);
   const [backup, setBackUp] = useState(rowData?.back === NAME_YES ? YES : NO);
   const [checkpointer, setCheckPointer] = useState(rowData?.check === NAME_YES ? YES : NO);
   const [deleteRedundantOrders, setDeleteRedundantOrders] = useState(rowData?.dro === NAME_YES ? YES : NO);
   const [orderReq, setOrderReq] = useState((rowData?.perm & BIT_MASK_ORDER_REQUEST) === BIT_MASK_ORDER_REQUEST ? 'Y' : 'N');
   const [orderPair, setOrderPair] = useState((rowData?.perm & BIT_MASK_ORDER_PAIR) === BIT_MASK_ORDER_PAIR ? 'Y' : 'N');
   const [tradeReq, setTradeReq] = useState((rowData?.perm & BIT_MASK_TRADE_REQUEST) === BIT_MASK_TRADE_REQUEST ? 'Y' : 'N');
   const [holdingsReq, setHoldingsReq] = useState((rowData?.perm & BIT_MASK_HOLDINGS_REQUEST) === BIT_MASK_HOLDINGS_REQUEST ? 'Y' : 'N');

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   // tab 1
   const [password, setPassword] = useState(DEFAULT_PASSWORD);
   const [confirmation_password, setConfirmationPassword] = useState(DEFAULT_PASSWORD);

   // Dropdown/shared state
   const [subjectUser, setSubjectUser] = useState(rowData?.code);
   const [status, setStatus] = useState(SUSPEND);
   const [role, setRole] = useState(rowData?.role ?? DROPDOWN_LIST_NONE);

   // Create user form
   const [description, setDescription] = useState(rowData?.descr ?? "");
   const [firm, setFirm] = useState(rowData?.firm ?? DROPDOWN_LIST_NONE);
   const [listeningPort, setListeningPort] = useState(rowData?.port ?? "");
   const [prometheusPort, setPrometheusPort] = useState(rowData?.prom ?? "");
   
   // to turn on and off fields depending on the role
   const SERVER_ROLES = Object.freeze([
      ROLE_DATAFEED_SERVER,
      ROLE_TRANSACTION_SERVER,
      ROLE_ALL_IN_ONE_SERVER,
   ]);
   
   const isServerRole = SERVER_ROLES.includes(Number(role));

   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const onUserDropDownChange = useCallback((e) => {setSubjectUser(e.target.value)}, [setSubjectUser]);
   const onFirmDropDownChange = useCallback((e) => {setFirm(e.target.value)}, [setFirm]);
   const onStatusDropDownChange = useCallback((e) => {setStatus(e.target.value)}, [setStatus]);
   const onRoleDropDownChange = useCallback((e) => {setRole(e.target.value)}, [setRole]);
   const onCancelAllOrdersDropDownChange = (e) => setCancelAllOrders(e.target.value);
   const onCoordinatorDropDownChange = useCallback((e) => {setCoordinator(e.target.value)}, [setCoordinator]);
   const onBackUpDropDownChange = useCallback((e) => {setBackUp(e.target.value)}, [setBackUp]);
   const onCheckPointerDropDownChange = useCallback((e) => {setCheckPointer(e.target.value)}, [setCheckPointer]);
   const onDeleteRedundantOrdersDropDownChange = useCallback((e) => {setDeleteRedundantOrders(e.target.value)}, [setDeleteRedundantOrders]);

   const onUserModifyDropDownChange = (e) => {
      setSubjectUser(e.target.value);
      setDescription('');
      setListeningPort('');
      setPrometheusPort('');
      setFirm(DROPDOWN_LIST_NONE);
      setRole(PUBLIC_DATA_ROLE_ID);
      setStatus(SUSPENDED);
   };

   const CalculatePermission = () => {
      let newPermission = 0;
      
      if (orderReq === 'Y') newPermission |= BIT_MASK_ORDER_REQUEST;
      if (orderPair === 'Y') newPermission |= BIT_MASK_ORDER_PAIR;
      if (tradeReq === 'Y') newPermission |= BIT_MASK_TRADE_REQUEST;
      if (holdingsReq === 'Y') newPermission |= BIT_MASK_HOLDINGS_REQUEST;
      
      return newPermission;
   };

   const handleStatusConfirmationSubmit = (submitItem) => {
      const base = {
         [JSON_KEY_SUBMITTER]: userId,
         [JSON_KEY_USER]: subjectUser,
      };

      switch (submitItem) {
         case ITEM_STATUS:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_CHANGE_USER_STATUS,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_USER_CHANGE_STATUS,
                  [JSON_KEY_WITHDRAW_ALL_ORDERS]: cancelAllOrders,
                  [JSON_KEY_STATUS]: status,
               }
            );
            break;

         case ITEM_FORCE_LOGOFF:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_CHANGE_USER_STATUS,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_USER_FORCE_LOGOFF,
               }
            );
            break;

         case ITEM_CANCEL_ALL_ORDERS:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_USER_CANCEL_ALL_ORDERS, // ← matches your original code
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_USER_CANCEL_ALL_ORDERS,
               }
            );
            break;

         case ITEM_CHANGE_COORDINATOR:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_CHANGE_COORDINATOR, // ← matches your original code
               {
                  ...base,
                  [JSON_KEY_COORDINATOR]: coordinator,
                  [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_CHANGE_COORDINATOR,
               }
            );
            break;

         case ITEM_CHANGE_BACKUP:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_CHANGE_BACKUP, // ← matches your original code
               {
                  ...base,
                  [JSON_KEY_BACKUP]: backup,
                  [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_CHANGE_BACKUP,
               }
            );
            break;

         case ITEM_PASSWORD:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_USER_PASSWORD,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_USER_PASSWORD,
                  [JSON_KEY_PASSWORD]: password,
               }
            );
            break;

         case ITEM_MODIFY: {
            const modify_user = {
               ...base,
               [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_USER_MODIFY,
               [JSON_KEY_DESCRIPTION]: description,
               [JSON_KEY_ROLE]: Number(role),
               [JSON_KEY_COORDINATOR]: coordinator,
               [JSON_KEY_BACKUP]: backup,
               [JSON_KEY_CHECKPOINTER]: checkpointer,
               [JSON_KEY_TR_DELETE_REDUNDANT_ORDERS]: deleteRedundantOrders,
               [JSON_KEY_PERMISSION]: CalculatePermission(),
               [JSON_KEY_STATUS]: status,
            };

            if (firm !== DROPDOWN_LIST_NONE) {
               modify_user[JSON_KEY_FIRM] = firm;
            }

            if (listeningPort || listeningPort === 0) {
               modify_user[JSON_KEY_LISTENING_PORT] = Number(listeningPort);
            }

            if (prometheusPort || prometheusPort === 0) {
               modify_user[JSON_KEY_PROMETHEUS_PORT] = Number(prometheusPort);
            }

            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               MSGTYPE_USER_MODIFY,
               modify_user
            );
            break;
         }

         case ITEM_CREATE: {
            const new_user = {
               ...base,
               [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_USER_CREATE,
               [JSON_KEY_DESCRIPTION]: description,
               [JSON_KEY_ROLE]: Number(role),
               [JSON_KEY_PASSWORD]: password,
               [JSON_KEY_COORDINATOR]: coordinator,
               [JSON_KEY_BACKUP]: backup,
               [JSON_KEY_CHECKPOINTER]: checkpointer,
               [JSON_KEY_TR_DELETE_REDUNDANT_ORDERS]: deleteRedundantOrders,
               [JSON_KEY_PERMISSION]: CalculatePermission(),
               [JSON_KEY_STATUS]: status,
            };

            if (firm !== DROPDOWN_LIST_NONE) {
               new_user[JSON_KEY_FIRM] = firm;
            }

            if (listeningPort || listeningPort === 0) {
               new_user[JSON_KEY_LISTENING_PORT] = Number(listeningPort);
            }

            if (prometheusPort || prometheusPort === 0) {
               new_user[JSON_KEY_PROMETHEUS_PORT] = Number(prometheusPort);
            }

            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               MSGTYPE_USER_CREATE,
               new_user
            );
            break;
         }

         default:
            console.log("UsersAdminForm unknown submit item");
      }
   };

   const handleCancelAllOrdersSubmit = () => {
      // const error = ValidateFields();
      // if (error) return ShowError(error);
      if (cancelAllOrders === NO) return ShowError("Cancel All Orders must be YES");

      ConfirmConfirmCancelAndSubmit({
         title: "User Cancel All Orders",
         text: `Do you want to cancel all orders on the user: ${subjectUser}`,
         item: ITEM_CANCEL_ALL_ORDERS,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose(); // your modal close function
   };

   const handleChangeCoordinatorSubmit = () => {

      ConfirmConfirmCancelAndSubmit({
         title: "Change Coordinator",
         text: `Do you want to change the Coordinator to: ${subjectUser}`,
         item: ITEM_CHANGE_COORDINATOR,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose(); // your modal close function
   };

   const handleChangeBackupSubmit = () => {

      ConfirmConfirmCancelAndSubmit({
         title: "Change Backup",
         text: `Do you want to change the Backup to: ${subjectUser}`,
         item: ITEM_CHANGE_BACKUP,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose(); // your modal close function
   };

   const handleStatusSubmit = () => {
      ConfirmConfirmCancelAndSubmit({
         title: "User Status Change",
         text: `Setting user ${subjectUser} to ${ConvertStatus(status)}`,
         item: ITEM_STATUS,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose();
   };

   const handleForceLogoffSubmit = () => {
      ConfirmConfirmCancelAndSubmit({
         title: "Force Logoff",
         text: `Force logoff of ${subjectUser}`,
         item: ITEM_FORCE_LOGOFF,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose();
   };

   const handlePasswordSubmit = () => {
      if (!password) return ShowError("Password is missing");
      if (!confirmation_password) return ShowError("Confirmation password is missing");
      if (password !== confirmation_password) return ShowError("Passwords do not match");

      ConfirmConfirmCancelAndSubmit({
         title: "User Password Change",
         text: `Setting password for user ${subjectUser}`,
         item: ITEM_PASSWORD,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose(); // your modal close function
   };

   const ValidateFields = () => {
      if (!subjectUser) return "User code is missing";
      if (!description) return "Description is missing";
      if (!role) return "Role is missing";
      if (!password) return "Password is missing";
      if (!confirmation_password) return "Confirmation password is missing";
      if (password !== confirmation_password) return "Passwords do not match";
      return null;
   };

   const handleCreateSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      // const confirmed = await confirmationDialog({ title, text });
      // if (confirmed) handleStatusConfirmationSubmit(item);
     
      ConfirmConfirmCancelAndSubmit({
         title: "Create User",
         text: `Creating new user: ${subjectUser}`,
         item: ITEM_CREATE,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose(); // your modal close function
   };

   const handleModifySubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmConfirmCancelAndSubmit({
         title: "Modify User",
         text: `Modifying user: ${subjectUser}`,
         item: ITEM_MODIFY,
         cancel_all: cancelAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose(); // your modal close function
   };

   // const CHECKPOINTER_ALLOWED_ROLES = [
   //    ROLE_DATAFEED_SERVER,
   //    ROLE_TRANSACTION_SERVER,
   //    ROLE_ALL_IN_ONE_SERVER,
   // ];

   // const isCheckPointerAllowed = useCallback((roleId) => {
   //    return CHECKPOINTER_ALLOWED_ROLES.includes(Number(roleId));
   // }, []);

   useEffect(() => {
      // Always set Check Pointer to NO when role changes (per requirement)
      // setCheckPointer(NO);

      if (isServerRole) {
         // Server role → force switches, deleteRedundant, firm to appropriate values
         setOrderReq('N');
         setTradeReq('N');
         setHoldingsReq('N');
         setOrderPair('N');
         setDeleteRedundantOrders(NO);
         setFirm(DROPDOWN_LIST_NONE);
         // Port and Prometheus Port remain untouched (they are read‑only)
      } else {
         // Non‑server role → clear port and prometheus port
         setListeningPort('');
         setPrometheusPort('');
         setCheckPointer(NO);
         // Do not touch switches, deleteRedundant, firm – they stay as the user set
      }
   }, [role, isServerRole]);


   // useEffect(() => {
   //    if (!isCheckPointerAllowed(role)) {
   //       setCheckPointer(NO);
   //    }
   // }, [role, isCheckPointerAllowed]);

   useEffect(() => {
      if (!rowData) return;
         setDescription(rowData.descr || '');
         setListeningPort(rowData.port || '');
         setPrometheusPort(rowData.prom || '');
         setCheckPointer(rowData.check === NAME_YES ? YES : NO);
         setFirm(rowData.firm || DROPDOWN_LIST_NONE);
         setSubjectUser(rowData.code || DROPDOWN_LIST_NONE);
         setStatus(rowData?.status ? ConvertStatusFromNameToId(rowData.status) : SUSPEND);
         setRole(ConvertToRoleId(rowData.role));
   }, [rowData]);

   useEffect(() => {
      if (selectedTabIndex === 3) {
         setStatus(SUSPENDED);
      }
   }, [selectedTabIndex]);

   return (
      <div className="admin-large-form">
         <div className="admin-large-tabs">
         <h2 className="center-heading">User Administration</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-largetabs" >
            <TabList>
               <Tab>Change Status</Tab>
               <Tab>User Password</Tab>
               <Tab>Force Logoff</Tab>
               <Tab>Modify User</Tab>
               <Tab>Create User</Tab>
               <Tab>Cancel All Orders</Tab>
               <Tab>Set Coordinator</Tab>
               <Tab>Set BackUp</Tab>
            </TabList>

            {/* Tab 1: Change Status */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleStatusSubmit)}>
                  <div className="top">
                     {RenderDropdown("User", subjectUser, userOptions, onUserDropDownChange)}
                  </div>
                  <div className="top">
                     {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
                  
                  </div>
                  {/*<div className="top">
                        {RenderDropdown("Cancel All Orders", cancelAllOrders, yesNoOptions, onCancelAllOrdersDropDownChange)}
                  </div>*/}

                  <div className="top">
                     {RenderDropdown(
                        "Cancel All Orders",
                        status === STATUS_ACTIVE ? NO : cancelAllOrders, // force NO if Active
                        yesNoOptions,
                        status === STATUS_ACTIVE ? () => {} : onCancelAllOrdersDropDownChange, // ignore changes if Active
                        status === STATUS_ACTIVE // disable dropdown if Active
                     )}
                  </div>

                  <div className="buttons">
                     <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                        Cancel
                     </Button>
                     <Button className="right-button" variant="success" size="lg" type="submit">
                        Submit
                     </Button>
                  </div>
               </form>
            </TabPanel>

            {/* Tab 2: Change Password */}
            <TabPanel>
               <form onSubmit={handleSubmit(handlePasswordSubmit)}>
                  <div className="top">
                     {RenderDropdown("User", subjectUser, userOptions, onUserDropDownChange)}
                  </div>

                  <div>
                     <label className="form-label">Password</label>
                     <input
                        className="form-medium-input"
                        type="password"
                        value={password}
                        onInput={(e) => setPassword(e.target.value)}
                     />
                     
                  </div>

                  <div>
                     <label className="form-label">Repeat Pasword</label>
                     <input
                        className="form-medium-input"
                        type="password"
                        value={confirmation_password}
                        onInput={(e) => setConfirmationPassword(e.target.value)}
                     />
                  </div>

                  <div className="buttons">
                     <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                        Cancel
                     </Button>
                     <Button className="right-button" variant="success" size="lg" type="submit">
                        Submit
                     </Button>
                  </div>
               </form>
            </TabPanel>

            {/* Tab 3: force logoff */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleForceLogoffSubmit)}>
                  <div className="top">
                     {RenderDropdown("User", subjectUser, userOptions, onUserDropDownChange)}
                  </div>

                  <div className="buttons">
                     <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                        Cancel
                     </Button>
                     <Button className="right-button" variant="success" size="lg" type="submit">
                        Submit
                     </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 4: Modify User */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleModifySubmit)}>
               <div className="top">
                  {RenderDropdown("User", subjectUser, userOptions, onUserModifyDropDownChange)}
               </div>

               <div>
                  <InputMediumField label="Description" value={description} onChange={setDescription} />
               </div>

               <div className="top">
                  {RenderDropdown("Firm", firm, firmOptions, onFirmDropDownChange, isServerRole)}
               </div>

               <div className="top">
                  {RenderDropdown("Role", role, roleOptions, onRoleDropDownChange)}
               </div>
{/*}
               <div className="top">
                  {RenderDropdown("Coordinator", coordinator, yesNoOptions, onCoordinatorDropDownChange, true)}
               </div>

               <div className="top">
                  {RenderDropdown("BackUp", backup, yesNoOptions, onBackUpDropDownChange, true)}
               </div>
 */}
               <div className="top">
               {RenderDropdown(
                  "Check Pointer",
                  checkpointer,
                  yesNoOptions,
                  onCheckPointerDropDownChange,
                  !isServerRole   
               )}
               </div>

               <div className="top"  style={{ whiteSpace: "nowrap" }}>
                  {RenderDropdown("Delete\u00A0Redundant Ords", deleteRedundantOrders, yesNoOptions, onDeleteRedundantOrdersDropDownChange, isServerRole)}
               </div>

               <div className="d-flex align-items-center mb-3" style={{ gap: '8.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Permissions
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Single Order" value={orderReq} onChange={setOrderReq} disabled={isServerRole} />
                     <SwitchField label="Single Trade" value={tradeReq} onChange={setTradeReq} disabled={isServerRole} />
                     <SwitchField label="Single Holdings" value={holdingsReq} onChange={setHoldingsReq} disabled={isServerRole} />
                     <SwitchField label="Order Pair" value={orderPair} onChange={setOrderPair} disabled={isServerRole} />
                  </div>
               </div>

               <div>
                  <InputMediumField label="Listening Port" value={listeningPort} onChange={setListeningPort} type="number" readOnly={!isServerRole} />
               </div>

               <div>
                  <InputMediumField label="Prometheus Port" value={prometheusPort} onChange={setPrometheusPort} type="number" readOnly={!isServerRole} />
               </div>

               {/*}
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange, true)}
               </div>
               */}
               
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
            
            {/* Tab 5: Create User */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCreateSubmit)}>
               <div>
                  <InputMediumField label="Code" value={subjectUser} onChange={setSubjectUser} />
               </div>

               <div>
                  <InputMediumField label="Description" value={description} onChange={setDescription} />
               </div>

               <div className="top">
                  {RenderDropdown("Firm", firm, firmOptions, onFirmDropDownChange, isServerRole)}
               </div>

               <div className="top">
                  {RenderDropdown("Role", role, roleOptions, onRoleDropDownChange)}
               </div>
{/*}
               <div className="top">
                  {RenderDropdown("Coordinator", coordinator, yesNoOptions, onCoordinatorDropDownChange, true)}
               </div>

               <div className="top">
                  {RenderDropdown("BackUp", backup, yesNoOptions, onBackUpDropDownChange, true)}
               </div>
 */}
               <div className="top">
               {RenderDropdown(
                  "Check Pointer",
                  checkpointer,
                  yesNoOptions,
                  onCheckPointerDropDownChange,
                  !isServerRole 
               )}
               </div>

               <div className="top">
                  {RenderDropdown("Delete\u00A0Redundant Ords", deleteRedundantOrders, yesNoOptions, onDeleteRedundantOrdersDropDownChange, isServerRole)}
               </div>

               <div className="d-flex align-items-center mb-3" style={{ gap: '8.5rem', paddingLeft: '0.5rem' }}>
                  <div style={{ minWidth: '150px', color: '#5791B9', fontSize: '16px' }}>
                     Permissions
                  </div>

                  <div className="d-flex gap-4">
                     <SwitchField label="Single Order" value={orderReq} onChange={setOrderReq} disabled={isServerRole} />
                     <SwitchField label="Single Trade" value={tradeReq} onChange={setTradeReq} disabled={isServerRole} />
                     <SwitchField label="Single Holdings" value={holdingsReq} onChange={setHoldingsReq} disabled={isServerRole} />
                     <SwitchField label="Order Pair" value={orderPair} onChange={setOrderPair} disabled={isServerRole} />
                  </div>
               </div>

               <div>
                  <InputMediumField label="Listening Port" value={listeningPort} onChange={setListeningPort} type="number" readOnly={!isServerRole} />
               </div>

               <div>
                  <InputMediumField label="Prometheus Port" value={prometheusPort} onChange={setPrometheusPort} type="number" readOnly={!isServerRole} />
               </div>

               <div>
                  <label className="form-label">Password</label>
                  <input
                     className="form-medium-input"
                     type="password"
                     value={password}
                     onInput={(e) => setPassword(e.target.value)}
                     disabled={isServerRole}
                  />
               </div>

               <div>
                  <label className="form-label">Repeat Pasword</label>
                  <input
                     className="form-medium-input"
                     type="password"
                     value={confirmation_password}
                     onInput={(e) => setConfirmationPassword(e.target.value)}
                     disabled={isServerRole}
                  />
               </div>

               {/*
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange, true)}
               </div>
               */}
               
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 6: Cancel All Orders */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCancelAllOrdersSubmit)}>
               <div className="top">
                  {RenderDropdown("User", subjectUser, userOptions, onUserDropDownChange)}
               </div>

               <div className="top">
                     {RenderDropdown("Cancel All Orders", cancelAllOrders, yesNoOptions, onCancelAllOrdersDropDownChange)}
               </div>
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>
            
            {/*Tab 7: Set Coordinator */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleChangeCoordinatorSubmit)}>
               <div className="top">
                  {RenderDropdown("Engine", coordinator, engineUsersOptions, onCoordinatorDropDownChange)}
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/*Tab 8: Set Backup */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleChangeBackupSubmit)}>
               <div className="top">
                  {RenderDropdown("Engine", backup, engineUsersOptions, onBackUpDropDownChange)}
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

         </Tabs>
         </div>
      </div>
   );
};

export default UsersAdminForm;
